import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';

const ConsentModal = ({ open, document, onClose, onAccept }) => {
  if (!document) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="paper">
      <DialogTitle>
        {document.title}
        {document.version && (
          <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
            v{document.version}
          </Typography>
        )}
      </DialogTitle>
      <DialogContent dividers>
        <Box
          sx={{
            '& h1': { fontSize: '1.5rem', mb: 2 },
            '& h2': { fontSize: '1.15rem', mt: 2, mb: 1 },
            '& p, & li': { mb: 1, lineHeight: 1.6 },
            '& ul': { pl: 3 },
          }}
          dangerouslySetInnerHTML={{ __html: document.content_html || '' }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        {onAccept && (
          <Button variant="contained" onClick={() => onAccept(document)}>
            I Agree
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ConsentModal;
